"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountRuleEntity = exports.DiscountRuleAuditLogEntity = exports.UsageByUserEntity = exports.DiscountConstraintsEntity = exports.PolygonEntity = exports.BundleItemEntity = exports.DiscountTierEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const types_1 = require("../../types");
class DiscountTierEntity {
    threshold;
    discount_type;
    discount_value;
    label;
}
exports.DiscountTierEntity = DiscountTierEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Threshold value to reach this tier",
        example: 1000,
    }),
    __metadata("design:type", Number)
], DiscountTierEntity.prototype, "threshold", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Type of discount in this tier",
        enum: ["percentage", "fixed_amount"],
        example: "percentage",
    }),
    __metadata("design:type", String)
], DiscountTierEntity.prototype, "discount_type", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Discount value for this tier",
        example: 10,
    }),
    __metadata("design:type", Number)
], DiscountTierEntity.prototype, "discount_value", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Label for this tier",
        example: "Gold",
    }),
    __metadata("design:type", String)
], DiscountTierEntity.prototype, "label", void 0);
class BundleItemEntity {
    display_id;
    category;
    min_quantity;
}
exports.BundleItemEntity = BundleItemEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display ID required in bundle",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], BundleItemEntity.prototype, "display_id", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Category of displays allowed in bundle",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], BundleItemEntity.prototype, "category", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Minimum quantity required",
        example: 1,
    }),
    __metadata("design:type", Number)
], BundleItemEntity.prototype, "min_quantity", void 0);
class PolygonEntity {
    type;
    coordinates;
}
exports.PolygonEntity = PolygonEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Geometry type",
        enum: ["Polygon"],
        example: "Polygon",
    }),
    __metadata("design:type", String)
], PolygonEntity.prototype, "type", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Polygon coordinates [[[lng, lat], ...]]",
        type: "array",
        items: {
            type: "array",
            items: {
                type: "array",
                items: {
                    type: "number",
                },
            },
        },
    }),
    __metadata("design:type", Array)
], PolygonEntity.prototype, "coordinates", void 0);
class DiscountConstraintsEntity {
    allowed_users;
    max_previous_purchases;
    allowed_displays;
    excluded_displays;
    allowed_display_list;
    excluded_display_list;
    allowed_display_tags;
    excluded_display_tags;
    allowed_display_categories;
    excluded_display_categories;
    allowed_display_groups;
    excluded_display_groups;
    allowed_contextual_data_services;
    excluded_contextual_data_services;
    allowed_coordinates;
    excluded_coordinates;
    min_cart_total;
    max_cart_total;
    min_displays_count;
    max_displays_count;
    min_plays_count;
    max_plays_count;
    max_discount_amount;
    min_campaign_days;
    max_campaign_days;
    min_total_hours;
    in_period;
    allowed_days_of_week;
    excluded_days_of_week;
    allowed_time_slots;
    requires_all_displays;
    requires_any_display;
    cannot_combine_with;
}
exports.DiscountConstraintsEntity = DiscountConstraintsEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed user IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_users", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum number of previous purchases allowed",
        example: 0,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "max_previous_purchases", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed display IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_displays", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded display IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_displays", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed display list IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_display_list", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded display list IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_display_list", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed display tag IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_display_tags", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded display tag IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_display_tags", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed display category IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_display_categories", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded display category IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_display_categories", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed display group IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_display_groups", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded display group IDs",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_display_groups", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed contextual data services",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_contextual_data_services", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded contextual data services",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_contextual_data_services", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed geographic zones (polygons)",
        type: [PolygonEntity],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_coordinates", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded geographic zones (polygons)",
        type: [PolygonEntity],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_coordinates", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Minimum cart total required",
        example: 500,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "min_cart_total", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum cart total allowed",
        example: 5000,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "max_cart_total", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Minimum number of displays required",
        example: 10,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "min_displays_count", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum number of displays allowed",
        example: 50,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "max_displays_count", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Minimum number of plays required",
        example: 1000,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "min_plays_count", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum number of plays allowed",
        example: 10000,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "max_plays_count", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum discount amount in currency",
        example: 200,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "max_discount_amount", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Minimum campaign duration in days",
        example: 7,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "min_campaign_days", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum campaign duration in days",
        example: 30,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "max_campaign_days", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Minimum total hours of broadcasting",
        example: 10,
    }),
    __metadata("design:type", Number)
], DiscountConstraintsEntity.prototype, "min_total_hours", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Campaign must be scheduled within this period",
        type: Object,
    }),
    __metadata("design:type", Object)
], DiscountConstraintsEntity.prototype, "in_period", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed days of the week (0=Sunday, 6=Saturday)",
        type: [Number],
        example: [0, 6],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_days_of_week", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Excluded days of the week (0=Sunday, 6=Saturday)",
        type: [Number],
        example: [1, 2, 3, 4, 5],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "excluded_days_of_week", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Allowed time slots",
        type: "array",
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "allowed_time_slots", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "All these displays must be included",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "requires_all_displays", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "At least one of these displays must be included",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "requires_any_display", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Cannot be combined with these discount codes",
        type: [String],
    }),
    __metadata("design:type", Array)
], DiscountConstraintsEntity.prototype, "cannot_combine_with", void 0);
class UsageByUserEntity {
    user_id;
    count;
    last_used;
    total_savings;
}
exports.UsageByUserEntity = UsageByUserEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User ID",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], UsageByUserEntity.prototype, "user_id", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of times used by this user",
        example: 3,
    }),
    __metadata("design:type", Number)
], UsageByUserEntity.prototype, "count", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Last usage date",
    }),
    __metadata("design:type", Date)
], UsageByUserEntity.prototype, "last_used", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Total savings for this user",
        example: 150.5,
    }),
    __metadata("design:type", Number)
], UsageByUserEntity.prototype, "total_savings", void 0);
class DiscountRuleAuditLogEntity {
    action;
    actor_user_id;
    at;
    changes;
    metadata;
}
exports.DiscountRuleAuditLogEntity = DiscountRuleAuditLogEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Audit action",
        enum: ["created", "updated", "activated", "deactivated", "cloned", "deleted"],
        example: "updated",
    }),
    __metadata("design:type", String)
], DiscountRuleAuditLogEntity.prototype, "action", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "User ID that performed the action",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DiscountRuleAuditLogEntity.prototype, "actor_user_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Action timestamp",
    }),
    __metadata("design:type", Date)
], DiscountRuleAuditLogEntity.prototype, "at", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Changed fields and before/after values",
        type: Object,
    }),
    __metadata("design:type", Object)
], DiscountRuleAuditLogEntity.prototype, "changes", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Additional audit metadata",
        type: Object,
    }),
    __metadata("design:type", Object)
], DiscountRuleAuditLogEntity.prototype, "metadata", void 0);
/**
 * Discount Rule entity representing promotional rules and pricing strategies
 */
class DiscountRuleEntity {
    id;
    name;
    description;
    code;
    auto_apply;
    is_active;
    is_deleted;
    internal_notes;
    created_by;
    valid_from;
    valid_to;
    priority;
    exclusive;
    type;
    target;
    value;
    tiers;
    tier_metric;
    buy_quantity;
    get_quantity;
    bundle_items;
    constraints;
    usage_limit_global;
    usage_limit_per_user;
    usage_reset_period_days;
    discount_budget_limit;
    current_usages;
    after_usage_send_discount;
    total_discount_applied;
    total_revenue_generated;
    conversion_rate;
    usage_by_user;
    audit_log;
    createdAt;
    updatedAt;
}
exports.DiscountRuleEntity = DiscountRuleEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the discount rule",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the discount rule",
        example: "Black Friday 2026",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Description of the discount rule",
        example: "20% off everything during Black Friday",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Discount code that users must enter (optional for auto-apply)",
        example: "BLACKFRIDAY",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "code", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether the discount applies automatically without a code",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DiscountRuleEntity.prototype, "auto_apply", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether the discount rule is active",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DiscountRuleEntity.prototype, "is_active", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether the discount rule was soft deleted",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DiscountRuleEntity.prototype, "is_deleted", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Internal notes for team use",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "internal_notes", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "User ID who created this rule",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "created_by", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Start date of validity",
    }),
    __metadata("design:type", Date)
], DiscountRuleEntity.prototype, "valid_from", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "End date of validity",
    }),
    __metadata("design:type", Date)
], DiscountRuleEntity.prototype, "valid_to", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Priority when multiple discounts apply (higher = higher priority)",
        example: 10,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "priority", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "If true, no other discounts can be applied with this one",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DiscountRuleEntity.prototype, "exclusive", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Type of discount",
        enum: types_1.DiscountType,
        example: types_1.DiscountType.PERCENTAGE,
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "type", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Target of the discount application",
        enum: types_1.DiscountTarget,
        example: types_1.DiscountTarget.TOTAL_CART,
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "target", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Discount value (percentage, amount, or fixed price)",
        example: 20,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "value", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Tiered discount levels",
        type: [DiscountTierEntity],
    }),
    __metadata("design:type", Array)
], DiscountRuleEntity.prototype, "tiers", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Metric used to calculate tier level",
        enum: types_1.TierMetric,
        example: types_1.TierMetric.CART_TOTAL,
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "tier_metric", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of items to buy (for buy X get Y)",
        example: 5,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "buy_quantity", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of items to get free (for buy X get Y)",
        example: 1,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "get_quantity", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Bundle items configuration",
        type: [BundleItemEntity],
    }),
    __metadata("design:type", Array)
], DiscountRuleEntity.prototype, "bundle_items", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Constraints and restrictions for applying this discount",
        type: DiscountConstraintsEntity,
    }),
    __metadata("design:type", DiscountConstraintsEntity)
], DiscountRuleEntity.prototype, "constraints", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Global usage limit (total uses allowed)",
        example: 100,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "usage_limit_global", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Usage limit per user",
        example: 1,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "usage_limit_per_user", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Days after which the per-user limit resets",
        example: 30,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "usage_reset_period_days", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Maximum total discount budget this rule can spend",
        example: 1000,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "discount_budget_limit", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Current number of times this discount has been used",
        example: 42,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "current_usages", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Discount rule ID to send after using this one",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DiscountRuleEntity.prototype, "after_usage_send_discount", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Total discount amount applied in currency",
        example: 5420.5,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "total_discount_applied", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Total revenue generated from this discount",
        example: 25000,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "total_revenue_generated", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Conversion rate percentage",
        example: 12.5,
    }),
    __metadata("design:type", Number)
], DiscountRuleEntity.prototype, "conversion_rate", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Usage statistics by user",
        type: [UsageByUserEntity],
    }),
    __metadata("design:type", Array)
], DiscountRuleEntity.prototype, "usage_by_user", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Audit log for discount rule changes",
        type: [DiscountRuleAuditLogEntity],
    }),
    __metadata("design:type", Array)
], DiscountRuleEntity.prototype, "audit_log", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Creation timestamp",
    }),
    __metadata("design:type", Date)
], DiscountRuleEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Last update timestamp",
    }),
    __metadata("design:type", Date)
], DiscountRuleEntity.prototype, "updatedAt", void 0);
